import { PLAY_MODES, getCurrentTimestamp } from "../Constants.js";

export default class Lastcard {

  static getCard = (index) => {
    let card = null;

    this.cards.forEach(item => {
      if(item.index === index) {
        card = {...item};
        return;
      }
    })

    return card;
  }

  static cards = [
    //kopa
    {
      character: "2",
      symbol: "kopa",
      value: 0,
      index: 1,
    },
    {
      character: "3",
      symbol: "kopa",
      value: 0,
      index: 2,
    },
    {
      character: "4",
      symbol: "kopa",
      value: 0,
      index: 3,
    },
    {
      character: "5",
      symbol: "kopa",
      value: 0,
      index: 4,
    },
    {
      character: "6",
      symbol: "kopa",
      value: 0,
      index: 5,
    },
    {
      character: "7",
      symbol: "kopa",
      value: 10,
      index: 6,
    },
    {
      character: "8",
      symbol: "kopa",
      value: 0,
      index: 7,
    },
    {
      character: "9",
      symbol: "kopa",
      value: 0,
      index: 8,
    },
    {
      character: "10",
      symbol: "kopa",
      value: 0,
      index: 9,
    },
    {
      character: "A",
      symbol: "kopa",
      value: 11,
      index: 10,
    },
    {
      character: "J",
      symbol: "kopa",
      value: 3,
      index: 11,
    },
    {
      character: "Q",
      symbol: "kopa",
      value: 2,
      index: 12,
    },
    {
      character: "K",
      symbol: "kopa",
      value: 4,
      index: 13,
    },

    //jembe
    {
      character: "2",
      symbol: "jembe",
      value: 0,
      index: 14,
    },
    {
      character: "3",
      symbol: "jembe",
      value: 0,
      index: 15,
    },
    {
      character: "4",
      symbol: "jembe",
      value: 0,
      index: 16,
    },
    {
      character: "5",
      symbol: "jembe",
      value: 0,
      index: 17,
    },
    {
      character: "6",
      symbol: "jembe",
      value: 0,
      index: 18,
    },
    {
      character: "7",
      symbol: "jembe",
      value: 10,
      index: 19,
    },
    {
      character: "8",
      symbol: "jembe",
      value: 0,
      index: 20,
    },
    {
      character: "9",
      symbol: "jembe",
      value: 0,
      index: 21,
    },
    {
      character: "10",
      symbol: "jembe",
      value: 0,
      index: 22,
    },
    {
      character: "A",
      symbol: "jembe",
      value: 11,
      index: 23,
    },
    {
      character: "J",
      symbol: "jembe",
      value: 3,
      index: 24,
    },
    {
      character: "Q",
      symbol: "jembe",
      value: 2,
      index: 25,
    },
    {
      character: "K",
      symbol: "jembe",
      value: 4,
      index: 26,
    },

    //kisu
    {
      character: "2",
      symbol: "kisu",
      value: 0,
      index: 27,
    },
    {
      character: "3",
      symbol: "kisu",
      value: 0,
      index: 28,
    },
    {
      character: "4",
      symbol: "kisu",
      value: 0,
      index: 29,
    },
    {
      character: "5",
      symbol: "kisu",
      value: 0,
      index: 30,
    },
    {
      character: "6",
      symbol: "kisu",
      value: 0,
      index: 31,
    },
    {
      character: "7",
      symbol: "kisu",
      value: 10,
      index: 32,
    },
    {
      character: "8",
      symbol: "kisu",
      value: 0,
      index: 33,
    },
    {
      character: "9",
      symbol: "kisu",
      value: 0,
      index: 34,
    },
    {
      character: "10",
      symbol: "kisu",
      value: 0,
      index: 35,
    },
    {
      character: "A",
      symbol: "kisu",
      value: 11,
      index: 36,
    },
    {
      character: "J",
      symbol: "kisu",
      value: 3,
      index: 37,
    },
    {
      character: "Q",
      symbol: "kisu",
      value: 2,
      index: 38,
    },
    {
      character: "K",
      symbol: "kisu",
      value: 4,
      index: 39,
    },

    //karanga
    {
      character: "2",
      symbol: "karanga",
      value: 0,
      index: 40,
    },
    {
      character: "3",
      symbol: "karanga",
      value: 0,
      index: 41,
    },
    {
      character: "4",
      symbol: "karanga",
      value: 0,
      index: 42,
    },
    {
      character: "5",
      symbol: "karanga",
      value: 0,
      index: 43,
    },
    {
      character: "6",
      symbol: "karanga",
      value: 0,
      index: 44,
    },
    {
      character: "7",
      symbol: "karanga",
      value: 10,
      index: 45,
    },
    {
      character: "8",
      symbol: "karanga",
      value: 0,
      index: 46,
    },
    {
      character: "9",
      symbol: "karanga",
      value: 0,
      index: 47,
    },
    {
      character: "10",
      symbol: "karanga",
      value: 0,
      index: 48,
    },
    {
      character: "A",
      symbol: "karanga",
      value: 11,
      index: 49,
    },
    {
      character: "J",
      symbol: "karanga",
      value: 3,
      index: 50,
    },
    {
      character: "Q",
      symbol: "karanga",
      value: 2,
      index: 51,
    },
    {
      character: "K",
      symbol: "karanga",
      value: 4,
      index: 52,
    },
    
  ]

  static shufflesCards = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
  }

  static isSelectionValid = (params) => {
    let {
      selectedCard,
      allSelectedCards,
      gameData,
    } = params;

    const playedCards = JSON.parse(gameData.boardData).playedCards;
    const specialEffect = JSON.parse(gameData.boardData).specialEffect;
    const topPlayedCard = playedCards[(playedCards.length - 1)];
    const topPlayedCardObj = this.getCard(topPlayedCard);
    const selectedCardObj = (selectedCard) ? this.getCard(selectedCard) : null;
    const cardRequest = JSON.parse(gameData.boardData).cardRequest;
    const playerCards = JSON.parse(gameData.playerData).availableCards;
    const opponentCards = JSON.parse(gameData.opponentData).availableCards;
    const topSelectedCard = (allSelectedCards) ? allSelectedCards[(allSelectedCards.length - 1)] : null;
    const topSelectedCardObj = (topSelectedCard) ? this.getCard(topSelectedCard) : null;

    if(selectedCard) {
      //validating only the selectedCard

      //check ownership
      let userCards = null;
      if(gameData.currentPlayer === gameData.opponentId) {
        userCards = opponentCards;
      } else if(gameData.currentPlayer === gameData.playerId) {
        userCards = playerCards;
      }

      if(userCards && userCards.indexOf(selectedCard) > -1) {
        //....
        if(allSelectedCards && allSelectedCards.length > 0) {
          //secondary selections
          /**
           * Seconadry selection should match the following conditions
           * 1)selectedCard character should be the same a the primary selection if prev card selection is not J
           * 2)If prev card is J then selectedCard can be any
           */
          if(allSelectedCards) {
            if(topSelectedCardObj.character === 'J') {
              //can be any
              return true;
            } else if(topSelectedCardObj.character === selectedCardObj.character) {
              return true;
            }
          }
        } else {
          //primary selection
          /**
           * Primary selection should meet the following set of conditions
           * SET 1 (if topPlayedCard is not J)
           *  1)Selected card should be J or
           *  2)Selected card should have the same character as topPlayedCard or
           *  3)Selected card should have the same symbol as selected card 
           * 
           * SET 2 (if topPlayedCard is J)
           *  2)Selected card must be J if topcard is not special or..
           *  1)Selected card can be yyt if there's no requestedcard, otherwise selected card must be similar to requested card
           *  
           */
          if(topPlayedCardObj.character === 'J') {
            if(selectedCardObj.character === 'J') {
              return true;
            } else {
              if(cardRequest && cardRequest.required) {
                if(cardRequest.required === 'any') {
                  return true;
                } else if(cardRequest.required === selectedCardObj.symbol) {
                  return true;
                } else if(cardRequest.required === 'special') {
                  if(
                    selectedCardObj.character === '2' ||
                    selectedCardObj.character === '7' ||
                    selectedCardObj.character === '8' 
                  ) {
                    return true;
                  }
                }
              } else {
                //yyt
                return true;
              }
            }
          } else {
            //check if there's a pending special effect in gameData
            if(specialEffect) {
              // check if last played card is special
              if(topPlayedCardObj.character === '2' || topPlayedCardObj.character === '7' || topPlayedCardObj.character === '8') {
                // only accept specials
                if(selectedCardObj.character === topPlayedCardObj.character) {
                  return true;
                }
              } else {
                //normal
                if(selectedCardObj.character === 'J') {
                  return true;
                } else if (selectedCardObj.character === topPlayedCardObj.character) {
                  return true;
                } else if (selectedCardObj.symbol === topPlayedCardObj.symbol) {
                  return true;
                }
              }
            } else {
              //normal
              if(selectedCardObj.character === 'J') {
                return true;
              } else if (selectedCardObj.character === topPlayedCardObj.character) {
                return true;
              } else if (selectedCardObj.symbol === topPlayedCardObj.symbol) {
                return true;
              }
            }
            
            
          }
        }
        //....
      }


      
    } else {
      //just validate the allSelectedCards

      //time travel through each selected card in allSelectedCard and use this same function to validate each selection
      if(allSelectedCards && allSelectedCards.length > 0) {
        let isAllValid = true;
        allSelectedCards.forEach((_selectedCard, _selectedCardIndex) => {
          //get allSelectedCards for this case
          const _allSelectedCards = allSelectedCards.filter((item, i) => {
            return (i < _selectedCardIndex); //only return elements with lower indices
          })

          const isValid = this.isSelectionValid({
            allSelectedCards: _allSelectedCards,
            selectedCard: _selectedCard,
            gameData,
          });

          //only capture false(s)
          if(!isValid) {
            isAllValid = false;
          }
        })

        return isAllValid;
      }
    }
    return false;
  }

  static canUserDeclareCard = (params) => {
    // returns false if can't and cardDeclarartion if can

    let {
      selectedCards,
      gameData,
      fromRamba,
      userId
    } = params;

    const boardData = JSON.parse(gameData.boardData);
    const playerData = JSON.parse(gameData.playerData);
    const opponentData = JSON.parse(gameData.opponentData);

    
    if(selectedCards && selectedCards.length > 0) {
      //check if currentPLayer has no pending declarations
      let hasCardDeclaration = false;
      if(boardData.cardDeclarations) {
        boardData.cardDeclarations.forEach(item => {
          if(item.userId === gameData.currentPlayer) {
            hasCardDeclaration = true;
          }
        })
      }

      if(!hasCardDeclaration) {
        ///....
        //get cards for the currentPlayer
        //not the user in this context is current player only in fromRamba context that's where we'll use provided userId

        let userCards = null;
        if(gameData.currentPlayer === gameData.playerId) {
          userCards = playerData.availableCards;
        } else if(gameData.currentPlayer === gameData.opponentId) {
          userCards = opponentData.availableCards;
        }

        if(userCards && userCards.length > 0) {
          //get unselected cards
          const unselectedCards = userCards.filter((item) => {
            return !(selectedCards.indexOf(item) > -1);
          })

          if(unselectedCards) {

            //get corresponding objects for the unselected cards
            const unselectedCardsObjs = unselectedCards.map((item, i) => {
              return this.getCard(item)
            })

            if(unselectedCards.length === 0) {
              //card ya kuchimba
              return {
                userId: gameData.currentPlayer,
                cards: null,
                type: 'chimba',
              }
            } else if(unselectedCards.length === 1) {
              //one card
              //check whether special or not
              if(
                unselectedCardsObjs[0].character === '2' ||
                unselectedCardsObjs[0].character === '7' ||
                unselectedCardsObjs[0].character === '8' ||
                unselectedCardsObjs[0].character === 'J'
              ) {
                //special card
                return {
                  userId: gameData.currentPlayer,
                  cards: unselectedCards,
                  type: 'special',
                }
              } else {
                //normal card
                return {
                  userId: gameData.currentPlayer,
                  cards: unselectedCards,
                  type: 'normal',
                }
              }
            } else if(unselectedCards.length > 1) {
              //check if they are all of the same character
              let areAllOfSameCharacter = true;
              const _character = unselectedCardsObjs[0].character;

              unselectedCardsObjs.forEach((item, i) => {
                if(item.character !== _character) {
                  areAllOfSameCharacter = false;
                }
              })

              if(areAllOfSameCharacter) {
                //more than one cards
                //check whether special or not
                if(
                  unselectedCardsObjs[0].character === '2' ||
                  unselectedCardsObjs[0].character === '7' ||
                  unselectedCardsObjs[0].character === '8' ||
                  unselectedCardsObjs[0].character === 'J'
                ) {
                  //special card
                  return {
                    userId: gameData.currentPlayer,
                    cards: unselectedCards,
                    type: 'special',
                  }
                } else {
                  //normal card
                  return {
                    userId: gameData.currentPlayer,
                    cards: unselectedCards,
                    type: 'normal',
                  }
                }
                //..
              }
            }
            
            
          }
        }
        ///....
      }
      
    } else {
      //check if it's from ramba
      if(fromRamba && userId) {
        //check if has pending cardDeclarations
        let hasCardDeclaration = false;
        if(boardData.cardDeclarations) {
          boardData.cardDeclarations.forEach(item => {
            if(item.userId === userId) {
              hasCardDeclaration = true;
            }
          })
        }

        if(!hasCardDeclaration) {
          ////...
          //just check if available cards for this player is 1 or they are all of the same character
          let userCards = null;

          //get usercards
          if(userId === gameData.playerId) {
            userCards = playerData.availableCards;
          } else if(userId === gameData.opponentId) {
            userCards = opponentData.availableCards;
          }

          if(userCards) {
            //get objs
            const userCardsObjs = userCards.map((item) => {
              return this.getCard(item);
            })

            if(userCards.length === 1) {
              //one card
              //check whether special or not
              if(
                userCardsObjs[0].character === '2' ||
                userCardsObjs[0].character === '7' ||
                userCardsObjs[0].character === '8' ||
                userCardsObjs[0].character === 'J'
              ) {
                //special card
                return {
                  userId,
                  cards: userCards,
                  type: 'special'
                }
              } else {
                //normal card
                return {
                  userId,
                  cards: userCards,
                  type: 'normal'
                }
              }

            } else if(userCards.length > 1) {
              //check if are all of the same character
              let areAllOfSameCharacter = true;
              let _character = userCardsObjs[0].character;

              userCardsObjs.forEach((item, i) => {
                if(item.character !== _character) {
                  areAllOfSameCharacter = false;
                }
              })

              if(areAllOfSameCharacter) {
                //check whether special or not
                if(
                  userCardsObjs[0].character === '2' ||
                  userCardsObjs[0].character === '7' ||
                  userCardsObjs[0].character === '8' ||
                  userCardsObjs[0].character === 'J'
                ) {
                  //special card
                  return {
                    userId,
                    cards: userCards,
                    type: 'special'
                  }
                } else {
                  //normal card
                  return {
                    userId,
                    cards: userCards,
                    type: 'normal'
                  }
                }
              }

            }
          }
          ////....
        }

        
      }
    }

    return false;
  }

  
}